import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../Navbar";
import { getData } from "../../../services/library";
import {
  Container,
  Grid,
  IconButton,
  ListItemIcon,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import { useFechas } from "../pedidosEnvasado/context/FechaContext";
import RefreshIcon from "@mui/icons-material/Refresh";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DeterminarPagos from "./determinarPagos/DeterminarPagos";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import CambiarPago from "./cambiarPago/CambiarPago";

function PedidosStandBy() {
  const [pedidosStandBy, setPedidosStandBy] = useState([]);
  const [determinarPago, setDeterminarPago] = useState(false);
  const [cambiarPago, setCambiarPago] = useState(false);
  const [pedido, setPedido] = useState({});
  const { desde, hasta, setDesde, setHasta } = useFechas();
  const esControlador=localStorage.getItem("controlador")

  const obtenerPedidos = () => {
    getData(
      "/envasado_pedidos/pedidosstandby/" +
        desde +
        " 00:00:00/" +
        hasta +
        " 23:59:59/" +
        localStorage.getItem("suc_auth").split(","),
      setPedidosStandBy,
    );
  };

  useEffect(() => {
    obtenerPedidos();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        maxSize: 50,
      },
      {
        accessorKey: "cliente",
        header: "Cliente",
        maxSize: 150,
      },
      {
        accessorKey: "direccion_entrega",
        header: "Dirección",
      },

      {
        accessorKey: "nombre_apellido",
        header: "Chofer",
      },
      {
        accessorKey: "valor",
        header: "Estado",
      },
      {
        accessorKey: "sucursal_cliente",
        header: "Sucursal",
        maxSize: 100,
      },
      {
        accessorKey: "fecha_para",
        header: "Fecha",
        maxSize: 80,
      },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };

  const handleUpdate = () => {
    obtenerPedidos();
  };

  const handleCloseDeterminarPagos = () => {
    setDeterminarPago(false);
    obtenerPedidos();
  };

  const handleCloseCambiarPago = () => {
    setCambiarPago(false);
    obtenerPedidos();
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 2 }}>
        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={pedidosStandBy ?? [{}]}
          layoutMode={"grid"}
          initialState={initialState}
          enableColumnActions={false} //deshabilita las acciones POR COLUMNA
          enableGlobalFilterModes={false}
          enableHiding={false}
          // enableRowActions={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn={"last"}
          enableExpandAll={false}
          enableToolbarInternalActions={true}
          muiTableHeadCellProps={tableHeadCellProps}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          enableDensityToggle={false}
          displayColumnDefOptions={displayColumnDefOptions}
          enableColumnResizing={true}
          muiTableBodyCellProps={({ row }) => ({
            align: "left",
            sx: {
              color: "black",
            },
          })}
          renderTopToolbarCustomActions={() => (
            <>
              <Grid container>
                <Grid item xs={3}>
                  <Typography variant="poster" fontSize={26}>
                    <DeleteIcon sx={{ fontSize: 20 }} />
                    Pedidos Descartados
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item>
                      <TextField
                        size="small"
                        label="Desde"
                        type="date"
                        value={desde}
                        onChange={(e) => setDesde(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        size="small"
                        label="Hasta"
                        type="date"
                        value={hasta}
                        onChange={(e) => setHasta(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item>
                      <Tooltip title="Actualizar">
                        <IconButton
                          onClick={handleUpdate}
                          sx={{
                            backgroundColor: "#e0e0e0",
                            "&:hover": { backgroundColor: "#d5d5d5" },
                          }}
                        >
                          <RefreshIcon sx={{ color: "#333" }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          enableRowActions={esControlador === 1 || esControlador === "1"} 
          renderRowActionMenuItems={({ closeMenu, row, index }) => {
            const menuItems = [];
            // Botón Determinar pago
            if (row.original.estado === 340 || row.original.estado === 350) {
              menuItems.push(
                <MenuItem
                  key={`determinar-${index}`}
                  onClick={() => {
                    setDeterminarPago(true);
                    setPedido(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <CurrencyExchangeIcon color="primary" />
                  </ListItemIcon>
                  Determinar pago
                </MenuItem>,
              );
            }

            // Botón Cambiar pago
            if (row.original.estado === 328) {
              menuItems.push(
                <MenuItem
                  key={`cambiar-${index}`}
                  onClick={() => {
                    setCambiarPago(true);
                    setPedido(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <CompareArrowsIcon color="warning" />
                  </ListItemIcon>
                  Cambiar de pedido el pago
                </MenuItem>,
              );
            }

            return menuItems;
          }}
        />
        {determinarPago ? (
          <DeterminarPagos
            determinarPago={determinarPago}
            pedido={pedido}
            onClose={() => handleCloseDeterminarPagos(false)}
          />
        ) : null}
        {cambiarPago ? (
          <CambiarPago
            cambiarPago={cambiarPago}
            pedido={pedido}
            onClose={() => handleCloseCambiarPago(false)}
          />
        ) : null}
      </Container>
    </>
  );
}

export default PedidosStandBy;